import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getLocalTranslation } from '../../utils/i18nKit';
export var useRecruitmentDeclaration = function useRecruitmentDeclaration() {
  var generateRecruitementDeclaration = function generateRecruitementDeclaration(config) {
    var _getLocalTranslation = getLocalTranslation(),
        $t = _getLocalTranslation.$t;

    var firstSpecList = [{
      text: $t('kit:convictions_ccjs_disqualifications'),
      list: [{
        text: $t('kit:brokerDeclarations.declaration_p1_principals_not_convicted')
      }, {
        text: $t('kit:brokerDeclarations.declaration_p1_principals_not_bankrupt')
      }]
    }, {
      text: $t('kit:previous_insurance'),
      list: [{
        text: $t('kit:never_declined_refused_insurance_cover')
      }]
    }];
    var materialFacts = {
      text: $t('kit:brokerDeclarations.material_facts'),
      list: []
    };

    if (config !== null && config !== void 0 && config.selectDirectorsAndOfficers) {
      materialFacts.list = [].concat(_toConsumableArray(materialFacts.list), [{
        text: $t('kit:brokerDeclarations.dir_positive_net_worth')
      }, {
        text: $t('kit:brokerDeclarations.dir_not_disqualified')
      }, {
        text: $t('kit:brokerDeclarations.dir_no_litigation')
      }, {
        text: $t('kit:brokerDeclarations.dir_excluded_sectors'),
        list: [{
          text: '• ' + $t('kit:sector_legal')
        }, {
          text: '• ' + $t('kit:sector_sports_clubs')
        }, {
          text: '• ' + $t('kit:sector_speculative_exploration')
        }, {
          text: '• ' + $t('kit:sector_biotech')
        }]
      }]);
    }

    if (config !== null && config !== void 0 && config.selectEmployerPracticesLiability) {
      materialFacts.list = [].concat(_toConsumableArray(materialFacts.list), [{
        text: $t('kit:recruitment_written_hr_manual_grievance')
      }, {
        text: $t('kit:recruitment_no_layoffs_12_months_planned')
      }, {
        text: $t('kit:recruitment_disciplinary_prior_review') + ' ' + $t('kit:recruitment_grievance_procedure_communicated')
      }, {
        text: $t('kit:brokerDeclarations.emp_no_usa_employees')
      }]);
    }

    if (config !== null && config !== void 0 && config.selectDriversNegligence) {
      materialFacts.list = [].concat(_toConsumableArray(materialFacts.list), [{
        text: $t('kit:recruitment_please_confirm_all_drivers'),
        list: [{
          text: '• ' + $t('kit:recruitment_drivers_aged_21_over')
        }, {
          text: '• ' + $t('kit:recruitment_drivers_valid_license_12_months')
        }, {
          text: '• ' + $t('kit:recruitment_drivers_60_days_last_9_months')
        }, {
          text: '• ' + $t('kit:recruitment_drivers_max_6_penalty_points')
        }]
      }]);
    }

    if (config !== null && config !== void 0 && config.showRecruitersTempContractPlacements) {
      firstSpecList.unshift({
        text: $t('kit:recruitment_temp_contract_placements'),
        list: [{
          text: $t('kit:not_liable_temp_staff')
        }]
      });
    }

    if (materialFacts.list.length > 0) {
      firstSpecList.push(materialFacts);
    }

    return {
      title: '',
      descTitle: '',
      confirmType: '1',
      spec: firstSpecList
    };
  };

  return {
    generateRecruitementDeclaration: generateRecruitementDeclaration
  };
};